import { render, staticRenderFns } from "./CommentThread.vue?vue&type=template&id=0f43b6b8&lang=pug&"
import script from "./CommentThread.vue?vue&type=script&lang=js&"
export * from "./CommentThread.vue?vue&type=script&lang=js&"
import style0 from "./CommentThread.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports